import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const isFor = ['Femei mature, cu carieră sau afacere, care se simt epuizate și deconectate de ele însele, dar au deschiderea să lucreze în profunzime', 'Femei care au încercat dezvoltare personală pe bucăți (cursuri, cărți, ateliere) și simt că le lipsește integrarea reală', 'Femei care vor un proces ghidat, structurat, nu doar informație, și sunt pregătite să își aloce 9 luni pentru ele'];
  const isNotFor = ['Pentru cine crede că are deja toate răspunsurile și caută doar o confirmare', 'Pentru cine nu vrea să privească onest ceea ce ar putea apărea în proces', 'Pentru cine este închis la minte și refuză soluții care combină psihologia cu metode mai puțin convenționale'];
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-394">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-395">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-396">
          {/* Is For Column */}
          <FadeIn data-id="element-397">
            <div className="bg-forest border border-forest-light rounded-[32px] p-8 md:p-12 h-full shadow-xl relative overflow-hidden" data-id="element-398">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -z-10" data-id="element-399"></div>

              <h3 className="text-2xl md:text-3xl font-serif font-medium text-ivory mb-8" data-id="element-400">
                Pentru cine este ANIMA Recode
              </h3>

              <ul className="space-y-6" data-id="element-401">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-402">
                    <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-1" data-id="element-403">
                      <Check className="w-4 h-4 text-gold" strokeWidth={3} data-id="element-404" />
                    </div>
                    <p className="text-[18px] text-ivory/80 leading-relaxed" data-id="element-405">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Is Not For Column */}
          <FadeIn delay={0.1} data-id="element-406">
            <div className="bg-ivory border border-gold/30 rounded-[32px] p-8 md:p-12 h-full shadow-soft relative overflow-hidden" data-id="element-407">
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-forest/5 rounded-full blur-3xl -z-10" data-id="element-408"></div>

              <h3 className="text-2xl md:text-3xl font-serif font-medium text-forest mb-8" data-id="element-409">
                Pentru cine <span className="italic" data-id="element-410">nu</span> este ANIMA Recode
              </h3>

              <ul className="space-y-6" data-id="element-411">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-412">
                    <div className="w-6 h-6 rounded-full bg-charcoal/10 flex items-center justify-center shrink-0 mt-1" data-id="element-413">
                      <X className="w-4 h-4 text-charcoal/60" strokeWidth={3} data-id="element-414" />
                    </div>
                    <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-415">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}